import React from "react";
import { Loader2 } from "lucide-react";

// Reusable share-action button. Used by ShareDialog (ClientDetail) and the Lead Machine modal.
// Style mirrors the existing "Condividi preventivo e contratto" dialog cards.
export default function ShareAction({ icon: Icon, label, hint, onClick, busy, disabled, testid }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="flex items-center gap-3 p-3 rounded-sm border border-border bg-white text-left transition-colors hover:border-primary hover:bg-secondary/30 disabled:opacity-50 disabled:cursor-not-allowed"
      data-testid={testid}
    >
      <span className="w-9 h-9 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
        {busy ? (
          <Loader2 className="w-4 h-4 text-primary animate-spin" strokeWidth={1.5} />
        ) : (
          <Icon className="w-4 h-4 text-primary" strokeWidth={1.5} />
        )}
      </span>
      <span className="min-w-0">
        <span className="block font-medium leading-tight">{label}</span>
        <span className="block text-[11px] text-neutral-500 truncate">{hint}</span>
      </span>
    </button>
  );
}
